import React, { useLayoutEffect, useRef, useState } from 'react';
import './IosAppBanner.css';

export default function IosAppBanner() {
  const [dismissed, setDismissed] = useState(false);
  const bannerRef = useRef(null);
  // Include Safari, Chrome and X's in-app browser on iPhone, but not iPad or desktop.
  const isIphoneBrowser = /iPhone|iPod/i.test(navigator.userAgent) &&
    !navigator.standalone && !window.matchMedia?.('(display-mode: standalone)').matches;
  const visible = isIphoneBrowser && !dismissed;

  useLayoutEffect(() => {
    if (!visible) return;
    const rootStyle = document.documentElement.style;
    const measure = () => rootStyle.setProperty('--ios-app-banner-height', `${bannerRef.current.getBoundingClientRect().height}px`);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(bannerRef.current);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
      rootStyle.removeProperty('--ios-app-banner-height');
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <aside ref={bannerRef} className="ios-app-banner" aria-label="iPhoneアプリのご案内">
      <div className="ios-app-banner__text">
        <strong>口語訳聖書</strong>
        <span>ASMRキリスト教会のiPhoneアプリ</span>
      </div>
      <a className="ios-app-banner__link" href="https://apps.apple.com/jp/app/id6747372843">App Storeで見る</a>
      <button type="button" className="ios-app-banner__close" aria-label="アプリの案内を閉じる" onClick={() => setDismissed(true)}>×</button>
    </aside>
  );
}
